// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'app-solid';

export const Component = () => (
  <path d='M1 18.63V6.369l10.823 6.082V24.52L1 18.629Zm22.605 0V6.369L12.782 12.45v12.07l10.823-5.891ZM1.815 5.89 12.301 0 22.79 5.89l-10.489 5.7-10.488-5.7Z' />
);

export const viewBox = '0 0 25 25';
